module.exports = global["Handlebars"] = require("-!./handlebars.js");


//////////////////
// WEBPACK FOOTER
// ../~/handlebars/dist/handlebars.js
// module id = 630
// module chunks = 0